export enum TributacaoTipo {
    Percentual = 0,
    Valor = 1,
}
